import { Option } from './option';
import { Category } from './category';
import { ProductLine } from './product-line';
import { AdminOptionCategory } from './admin-option-category';
import { AdminOption } from './admin-option';

export class OptionsAdmin {
    public Options: Option[];
    public Categories: Category[];
    public ProductLines: ProductLine[];
    public CustomerCategories: AdminOptionCategory[];
    public CurrentPage: number;
    public TotalPageCount: number;

    constructor() {
        this.Options = new Array<Option>();
        this.Categories = new Array<Category>();
        this.ProductLines = new Array<ProductLine>();
        this.CustomerCategories = new Array<AdminOptionCategory>();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/model/options-admin.ts